import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-hotels-selection',
  templateUrl: './user-hotels-selection.component.html',
  styleUrls: ['./user-hotels-selection.component.scss'],
})
export class UserHotelsSelectionComponent  implements OnInit {

  constructor(
    private _router: Router
  ) { }

  ngOnInit() {}

  onSubmit(){
    this._router.navigate(['/vehicles-selection']);
  }


}
